import { HTTP } from 'providers'

export class CompanyGroupService extends HTTP {
  private endpoint = '/company-group/'

  public fetchAllCompanyGroup() {
    return this.get({ endpoint: this.endpoint })
  }
}
